import React from "react";

/* eslint-disable max-len */
function SettingIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={100} height={80} viewBox="0 0 100 80">
            <path
                d="M70.4 36.3L100 76.2V5a4.951 4.951 0 00-5-5H5a4.951 4.951 0 00-5 5v70a4.951 4.951 0 005 5h49.7L36.9 56.2z"
                fill="#909090"
            />
            <path
                d="M100 76.1L70.3 35.7 36.7 55.9 54.6 80h41.5a3.842 3.842 0 003.9-3.9z"
                fill="#807f7f"
            />
            <path
                d="M71.7 39.4a19.269 19.269 0 01-.1 2.4 1.63 1.63 0 01-1.1 1.3c-.8.2-1.7.5-2.7.8-1.1.3-1.2 1.2-1.6 2.1s-.9 1.7-.3 2.7c.5.9.9 1.7 1.3 2.5a1.514 1.514 0 01-.2 1.7 21.861 21.861 0 01-3.4 3.4 1.749 1.749 0 01-1.7.2c-.7-.4-1.6-.8-2.5-1.3-1-.5-1.7 0-2.7.3-.9.4-1.8.6-2.1 1.6s-.6 1.9-.8 2.7a1.63 1.63 0 01-1.3 1.1 19.269 19.269 0 01-2.4.1 19.269 19.269 0 01-2.4-.1 1.63 1.63 0 01-1.3-1.1c-.2-.8-.5-1.7-.8-2.7-.3-1.1-1.2-1.2-2.1-1.6s-1.7-.9-2.7-.3c-.9.5-1.7.9-2.5 1.3a1.514 1.514 0 01-1.7-.2 21.861 21.861 0 01-3.4-3.4 1.749 1.749 0 01-.2-1.7c.4-.7.8-1.6 1.3-2.5.5-1 0-1.7-.3-2.7-.4-.9-.6-1.8-1.6-2.1s-1.9-.6-2.7-.8a1.63 1.63 0 01-1.1-1.3 19.269 19.269 0 01-.1-2.4 19.269 19.269 0 01.1-2.4 1.63 1.63 0 011.1-1.3c.8-.2 1.7-.5 2.7-.8 1.1-.3 1.2-1.2 1.6-2.1s.9-1.7.3-2.7c-.5-.9-.9-1.7-1.3-2.5a1.514 1.514 0 01.2-1.7 21.861 21.861 0 013.4-3.4 1.749 1.749 0 011.7-.2c.7.4 1.6.8 2.5 1.3 1 .5 1.7 0 2.7-.3.9-.4 1.8-.6 2.1-1.6s.6-1.9.8-2.7a1.63 1.63 0 011.3-1.1 19.269 19.269 0 012.4-.1 19.269 19.269 0 012.4.1 1.63 1.63 0 011.3 1.1c.2.8.5 1.7.8 2.7.3 1.1 1.2 1.3 2.1 1.6.9.4 1.7.9 2.7.3.9-.5 1.7-.9 2.5-1.3a1.514 1.514 0 011.7.2 21.861 21.861 0 013.4 3.4 1.749 1.749 0 01.2 1.7c-.4.7-.8 1.6-1.3 2.5-.5 1 0 1.7.3 2.7.4.9.6 1.8 1.6 2.1s1.9.6 2.7.8a1.63 1.63 0 011.1 1.3c0 .8.1 1.6.1 2.4z"
                fill="#c9c1c2"
            />
            <circle cx={13} cy={13} r={13} transform="translate(36.9 26.4)" fill="#999091" />
            <circle cx={8.7} cy={8.7} r={8.7} transform="translate(41.2 30.7)" fill="#d5cccd" />
        </svg>
    );
}

export default SettingIcon;
